@use '@/styles/tokens' as *;

.card {
  display: flex;
  flex-direction: column;
  gap: var(--space-8);
  background: $color-neutral-0;
}

.metaRow {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-3);
}

.createdOn {
  flex: 0 0 auto;
  font-size: 10px;
  color: $color-neutral-600;
}

.createdDate {
  color: $color-neutral-800;
}

.valueBlock {
  display: flex;
  flex-direction: column;
  gap: 7px;
}

.value {
  margin: 0;
  font-family: $font-family-heading;
  font-size: 28px;
  font-weight: 400;
  letter-spacing: -0.56px;
  color: $color-neutral-950;
}

.trigger {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: $color-neutral-950;
}

.help {
  margin: 0;
  font-size: 12px;
  color: $color-neutral-600;
}

.field {
  display: flex;
  flex-direction: column;
  gap: var(--space-1);
}

.label {
  font-size: 12px;
  color: $color-neutral-600;
}

.fieldValue {
  font-size: 14px;
  color: $color-neutral-950;
}

.description {
  display: -webkit-box;
  margin: 0;
  overflow: hidden;
  font-size: 14px;
  color: $color-neutral-950;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
